import { render, staticRenderFns } from "./mypid.vue?vue&type=template&id=2b1d1ab0&scoped=true"
import script from "./mypid.vue?vue&type=script&lang=js"
export * from "./mypid.vue?vue&type=script&lang=js"
import style0 from "./mypid.vue?vue&type=style&index=0&id=2b1d1ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1d1ab0",
  null
  
)

export default component.exports